import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Header from './Header'
import MapContainer from './MapContainer'
import Container from './Container'
import BoardContainer from './BoardContainer'
import MenuTab from './MenuTab'
import styledComponents from '../styles/Container-style'
import axios from 'axios'
import { useQuery } from 'react-query'
// import MenuTabAnimation from './MenuTabAnimation'

import moment from 'moment';
import 'moment/locale/ko';
import { buildYearList } from '../config/yearConfig';

const { WebContainer, WebContainerCol01, WebContainerCol02, BottomNavContainer, IconContainer, Icon } = styledComponents;

// 48개 시군구 지역 폴리곤 데이터
const fetchAreaData = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/svc/5`)
    return data
}

const fetchInvestigationData = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/surveys`)
    return data
}

const TopContainer = (props) => {
    const { menu, handleMenuId, YearUrl, getYearId, SelectedPrevYear, handleSelectPrevYear, SelectedPrevYearAreaChange } = props;
    const { data, error, isError, isLoading } = useQuery('area', fetchAreaData);
    // const { data, error, isError, isLoading } = useQuery('investigate', fetchInvestigationData);
    const [SelectedAreaName, setSelectedAreaName] = useState('대한민국')
    const [SelectedTabId, setSelectedTabId] = useState(0)
    const [isMobile, setisMobile] = useState(false)

    const [SelectedAreaInfo, setSelectedAreaInfo] = useState({ SD: '대한민국', SG: null })

    const [Table, setTable] = useState(null)
    const [isTable, setisTable] = useState(false)
    const [LabName, setLabName] = useState('')
    const [TableAreaName, setTableAreaName] = useState('')
    const [InvestigationType, setInvestigationType] = useState('')
    const [ImageList, setImageList] = useState([])


    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());


    const yearAll = useMemo(() => buildYearList(menu), [menu]);

    let areaSelect = [];
    const generateAreaSelect = useCallback(() => {
        if (data) {
            data.features.map(item => {
                let area = {};
                area.value = item.properties.SG;
                area.label = item.properties.SG;
                area.SD = item.properties.SD;
                area.SG = item.properties.SG;
                area.coordinates = item.geometry.coordinates[0][0]
                areaSelect.push(area);
                return areaSelect;
            })
            return areaSelect;
        }
    }, [data]);

    areaSelect = useMemo(() => generateAreaSelect(), [generateAreaSelect]);

    useEffect(() => {
        if (data && data !== undefined) {
            generateAreaSelect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        if (windowDimensions.width < 806) {
            setisMobile(true)
        } else {
            setisMobile(false)
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // console.log('카테고리 변경')
        // console.log(menu)
        setisTable(false)
        setSelectedAreaInfo({ SD: '대한민국', SG: null })
        setSelectedAreaName('대한민국')
    }, [menu]);


    const handleSelectedAreaName = (areaName) => {
        setSelectedAreaName(areaName)
    }

    const handleSelectedAreaInfo = (areaInfo) => {
        setSelectedAreaInfo(areaInfo)
    }

    const dataInvestigation = useQuery('investigation', () => fetchInvestigationData());

    // 데이터 메뉴탭 select
    const handleSelect = (index) => {
        setSelectedTabId(index)
        if (index === 2) {
            fetchInvestigationData()
        }
    }
    const arr = ['분포 면적', '', '현장조사']; // 분포면적 - 현장조사 사이 빈 버튼 클릭방지 pointerEvents: none
    const renderTabs = arr.map((tab, index) => {
        return (
            <div key={index} style={{pointerEvents: index != 1? 'initial': 'none'}}>
                <IconContainer
                    onClick={() => handleSelect(index)}
                    selected={SelectedTabId === index ? true : ''}
                >
                    {index === 0 &&
                        <>
                            {SelectedTabId === 0 ?
                                <Icon src="./images/distributionIconFill.svg"
                                    style={{ width: "18px", height: "18px", stroke: "blue" }}
                                    alt="분포" />
                                : <Icon src="./images/distributionIcon.svg"
                                    style={{ width: "18px", height: "18px" }}
                                    alt="분포" />
                            }
                        </>
                    }
                    {/* {index === 1 &&
                        <>
                            {SelectedTabId === 1 ?
                                <Icon src="./images/Co2_IconFill.svg"
                                    style={{ width: "29px", height: "22px" }}
                                    alt="co2" />
                                : <Icon src="./images/Co2_Icon.svg"
                                    style={{ width: "29px", height: "22px" }}
                                    alt="co2" />
                            }
                        </>
                    } */}
                    {index === 2 &&
                        <>
                            {SelectedTabId === 2 ?
                                <Icon src="./images/investiagteIconFill.svg"
                                    style={{ width: "18px", height: "18px" }}
                                    alt="현장" />
                                : <Icon src="./images/investiagteIcon.svg"
                                    style={{ width: "18px", height: "18px" }}
                                    alt="현장" />
                            }
                        </>

                    }
                    <div>{tab}</div>
                </IconContainer>
            </div>
        )
    })

    const htmlToJson = () => {
        // const tableFirst = document.getElementsByTagName('tr')[1];
        // const tableSecond = document.getElementsByTagName('tr')[4];
        // const firstRow = tableFirst.getElementsByTagName('td');
        // const investigationType = firstRow[0] ? firstRow[0].textContent.replace(/\s+/g, " ").trim() : '';
        // const investigationLab = firstRow[1] ? firstRow[1].textContent.replace(/"/g, " ").trim() : '';

        // if (tableSecond) {
        //     const secondRow = tableSecond.getElementsByTagName('td');
        //     // console.log('secondRow', secondRow)
        //     const investigationAreaNameSplit = secondRow[1] ? secondRow[1].textContent.split("_") : '';
        //     const investigationAreaName = investigationAreaNameSplit[0] ? investigationAreaNameSplit[0].replace(/"/g, " ").trim() : '';
        //     // console.log(investigationAreaNameSplit, 'investigationAreaNameSplit', investigationAreaName)
        //     // console.log('investigationAreaName', investigationAreaName)
        //     setTableAreaName(investigationAreaName)
        // } else {
        //     setTableAreaName("")
        // }

        const tableData = document.getElementsByTagName('tr')[0].getElementsByTagName('td');
        // console.log('tableData', tableData)

        if (tableData) {
            setTableAreaName(tableData[0]? tableData[0].textContent.replace(/\s+/g, " ").trim() : '');
            setLabName(tableData[1]? tableData[1].textContent.replace(/\s+/g, " ").trim() : '');
        }

        const investigationTypeDict = { 0: '퇴적물', 1: '해초대', 2:'염습지'}
        const investigationType = investigationTypeDict[menu]
        setInvestigationType(investigationType)

        // console.log('investigationType', tableData[0])
        // console.log('investigationLab', tableData[1])
    }

    const handleTable = (data) => {
        setTable(data);
        setisTable(true);
        htmlToJson();
    }

    const handleReturnInvestigationMain = () => {
        setisTable(false)
    }

    const handleImageList = (item) => {
        setImageList(item)
    }


    if (isLoading) {
        return <div>Loading...</div>
    }
    if (isError) {
        return <div>Error! {error.message}</div>
    }

    return (
        <>
            <WebContainer>
            {menu !==3 &&   
                <WebContainerCol02>
                
                    {/* 지역선택 */}
                    <Header SelectedAreaName={SelectedAreaName} menu={menu} SelectedTabId={SelectedTabId} isTable={isTable} TableAreaName={TableAreaName} />
                    <MapContainer
                        YearUrl={YearUrl}
                        areaSelect={areaSelect}
                        SelectedAreaName={SelectedAreaName}
                        handleSelectedAreaName={handleSelectedAreaName}
                        SelectedTabId={SelectedTabId}
                        areaDataUrl={data}
                        dataInvestigation={dataInvestigation.data}
                        MenuId={menu}
                        SelectedAreaInfo={SelectedAreaInfo}
                        handleSelectedAreaInfo={handleSelectedAreaInfo}
                        SelectedPrevYear={SelectedPrevYear}
                        handleSelectPrevYear={handleSelectPrevYear}
                        SelectedPrevYearAreaChange={SelectedPrevYearAreaChange}
                        handleTable={handleTable}
                        Table={Table}
                        handleImageList={handleImageList}
                    />

                    {/* 데이터 메뉴탭 */}
                    <BottomNavContainer>
                        {renderTabs}
                    </BottomNavContainer>

                    {/* 데이터 시각화 패널 */}
                    <Container
                        yearList={yearAll}
                        getYearId={getYearId}
                        YearUrl={YearUrl}
                        SelectedTabId={SelectedTabId}
                        menu={menu}
                        SelectedAreaInfo={SelectedAreaInfo}
                        SelectedPrevYear={SelectedPrevYear}
                        handleSelectPrevYear={handleSelectPrevYear}
                        SelectedPrevYearAreaChange={SelectedPrevYearAreaChange}
                        Table={Table}
                        isTable={isTable}
                        LabName={LabName}
                        InvestigationType={InvestigationType}
                        TableAreaName={TableAreaName}
                        handleReturnInvestigationMain={handleReturnInvestigationMain}
                        ImageList={ImageList}
                    />               
                </WebContainerCol02>
            }
            {menu === 3 &&
                <WebContainerCol02>
                    <Header SelectedAreaName={SelectedAreaName} menu={menu} SelectedTabId={SelectedTabId} isTable={isTable} TableAreaName={TableAreaName} />
                    <BoardContainer
                        menu={menu}
                    />
                </WebContainerCol02>
            }
                <WebContainerCol01>
                    <MenuTab handleMenuId={handleMenuId} MenuId={menu} />
                    {/* <MenuTabAnimation
                        handleMenuId={handleMenuId}
                        isMobile={isMobile}
                        MenuId={menu} /> */}
                </WebContainerCol01>
            </WebContainer>
            {/* {Table &&
                <div dangerouslySetInnerHTML={{ __html: Table }}
                    style={{ height: "0px", display: "none" }}></div>
            } */}
            <table style={{display: 'none'}}><tbody>
                {Table && Table.map((item, i) => (
                    <tr key={i} dangerouslySetInnerHTML={{
                        __html: '<td>'+item.vtx_nm+'</td>' + '<td>'+item.instt+'</td>'
                    }}>
                    </tr>
                ))}
            </tbody></table>
        </>
    )
};

export default TopContainer;
